(() => {
  const script = document.currentScript;
  const message = script?.dataset.invalidVideo || 'Enter a valid YouTube video link.';
  const isVideoField = input => input instanceof HTMLInputElement && /^properties\[/i.test(input.name) && /youtube/i.test(input.name) && /video|vidéo|vídeo|فيديو/i.test(input.name);
  function videoUrl(value) {
    try {
      const raw = String(value || '').trim();
      const url = new URL(/^https?:\/\//i.test(raw) ? raw : `https://${raw}`);
      if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.port) return '';
      const host = url.hostname.toLowerCase().replace(/^(www\.|m\.)/, '');
      const path = url.pathname.replace(/\/$/, '');
      const id = host === 'youtu.be' ? path.slice(1) : host === 'youtube.com' ? (path === '/watch' ? url.searchParams.get('v') : path.match(/^\/(?:shorts|live|embed)\/([^/]+)$/)?.[1]) : '';
      if (!/^[\w-]{11}$/.test(id || '')) return '';
      url.protocol = 'https:';
      return url.href;
    } catch (_) { return ''; }
  }
  function update(input) {
    if (!isVideoField(input)) return;
    input.inputMode = 'url';
    input.placeholder = 'https://www.youtube.com/watch?v=...';
    input.setCustomValidity(input.value.trim() && !videoUrl(input.value) ? message : '');
  }
  document.addEventListener('focusin', event => update(event.target), true);
  document.addEventListener('input', event => update(event.target), true);
  document.addEventListener('change', event => update(event.target), true);
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement)) return;
    for (const input of event.target.elements) {
      if (!isVideoField(input) || input.disabled) continue;
      const normalized = videoUrl(input.value);
      if (!normalized) {
        event.preventDefault();
        event.stopImmediatePropagation();
        input.setCustomValidity(message);
        input.reportValidity();
        input.focus();
        return;
      }
      input.setCustomValidity('');
      input.value = normalized;
    }
  }, true);
  document.querySelectorAll('input[name^="properties["]').forEach(update);
})();
